<template>
  <div
    class="yxtbiz-ote-ai-textarea"
    :id="id"
    :class="{
      'yxtbiz-ote-ai-textarea--focus': focus,
      'yxtbiz-ote-ai-textarea--disabled': disabled,
      'yxtbiz-ote-ai-textarea--sub': showSub
    }"
    @click="startInput"
  >
    <!-- 顶部自定义内容 -->
    <div
      class="yxtbiz-ote-ai-textarea__header flex flex-mid mb12"
      v-if="$slots.header"
    >
      <div class="flex-g-1 shrink1 overflow-hiden">
        <slot name="header"></slot>
      </div>
    </div>
    <!-- 顶部输入框收起状态 -->
    <div
      class="yxtbiz-ote-ai-textarea__header flex flex-mid"
      v-else-if="$slots.contentSub"
    >
      <!-- 顶部收起状态下的输入框，点击可展开 -->
      <div class="flex-g-1 shrink1 overflow-hiden">
        <div class="yxtbiz-ote-ai-textarea__sub-input">
          <YxtbizOteAiTextarea
            ref="txtAsk"
            v-model="txt"
            :maxlength="maxlength"
            :disabled="disabled||subDisabled"
            :btnTip="btnTip"
            :subTip="subTip"
            :canBlur="canBlur"
            :canSave="canSave"
            :btnText="btnText"
            @save="saveSub"
            @focus="showSubInput(true)"
            @blur="showSubInput(false)"
            :placeholder="placeholder"
          >
            <slot name="subinfo" slot="subinfo"></slot>
            <slot name="options" slot="options"></slot>
          </YxtbizOteAiTextarea>
        </div>
      </div>
      <!-- 子输入框右侧可自定义内容 -->
      <div class="flex flex-mid shrink0 z-index-20" v-if="$slots.contentSub">
        <slot name="contentSub"></slot>
      </div>
    </div>

    <!-- 中间输入框主体、或者自定义展示内容 -->
    <div class="yxtbiz-ote-ai-textarea__content" v-if="$slots.content">
      <yxt-scrollbar :fit-height="true">
        <slot name="content"></slot>
      </yxt-scrollbar>
    </div>
    <template v-else>
      <div class="yxtbiz-ote-ai-textarea__txt">
        <textarea
          ref="inputRef"
          :maxlength="maxlength"
          v-model="txt"
          :placeholder="placeholder"
        />
        <span class="yxtbiz-ote-ai-textarea__txt-fake ellipsis" @click.stop="">
          <div class="ellipsis mr12 hand" @click.stop="startInput">{{ txt || subTip }}</div>
          <div v-if="!disabled" class="yxtbiz-ote-ai-icon hand" @click.stop="startInput">
            <yxt-svg width="16px" height="16px" icon-class="edit"></yxt-svg>
          </div>
        </span>
        <slot name="sub"></slot>
      </div>
      <div class="yxtbiz-ote-ai-textarea__subinfo">
        <slot name="subinfo"></slot>
      </div>
      <div
        class="yxtbiz-ote-ai-textarea__btns"
        :class="{
          'yxtbiz-ote-ai-textarea__btns--text': btnText
        }"
      >
        <div class="yxtbiz-ote-ai-textarea__options">
          <slot name="options"></slot>
        </div>
        <div>
          <span class="color-gray-7">{{ txt.length }}</span
          ><span class="color-gray-6">/{{ maxlength }}</span>
        </div>
        <template v-if="(txt && txt.trim()) || canSave">
          <div class="yxtbiz-ote-ai-icon hand">
            <yxt-svg
              @click.native="txt = ''"
              :remote-url="SvgMediaNewUrl"
              width="16px"
              height="16px"
              class="hand"
              icon-class="ai-clean-cc"
            ></yxt-svg>
          </div>
          <yxt-tooltip :disabled="!btnTip || !focus" :content="btnTip" 
              placement="top" v-if="!btnText && !hideBtn">
            <div @click="save" class="yxtbiz-ote-ai-textarea__btn-pub">
              <yxt-svg
                :remote-url="SvgMediaNewUrl"
                width="16px"
                height="16px"
                class="hand"
                icon-class="ai-publish"
              ></yxt-svg>
            </div>
          </yxt-tooltip>
        </template>
        <div v-if="btnText && !hideBtn && ((txt && txt.trim()) || canSave)">
          <div
            class="yxtbiz-ai-create-txt-btn" 
            @click="save"
          >
            {{ btnText }}
          </div>
        </div>
      </div>
    </template>
    <!-- 底部自定义 -->
    <div v-if="$slots.contentBottomSub" class="yxtbiz-ote-ai-textarea__bottom-sub">
      <slot name="contentBottomSub"></slot>
    </div>
    <!-- 底部自定义操作按钮 -->
    <div v-if="$slots.contentBottom" class="yxtbiz-ote-ai-textarea__bottom">
      <slot name="contentBottom"></slot>
    </div>
  </div>
</template>

<script>
import { SvgMediaNewUrl } from '../const';
export default {
  name: 'YxtbizOteAiTextarea',
  props: {
    value: {
      type: String,
      default: ''
    },
    subTip: {
      type: String,
      default: ''
    },
    subDisabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideBtn: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: String,
      default: ''
    },
    btnTip: {
      type: String,
      default: ''
    },
    canSave: {
      type: Boolean,
      default: false
    },
    canBlur: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showSub: false,
      SvgMediaNewUrl,
      txt: this.value,
      id: 'ote-ue-' + new Date().getTime() + this._uid,
      focus: false // 当前是否聚焦为输入中状态
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.txt = val;
      }
    },
    txt: {
      immediate: true,
      handler(val) {
        val !== this.value && this.$emit('input', val);

        // if (!this.focus && val) {
        //   this.startInput();
        // }
      }
    },
    disabled: {
      immediate: true,
      handler(val) {
        if (val && this.focus) {
          // this.blur();
        }
      }
    }
  },
  mounted() {
    // 处理聚焦失焦状态切换
    this.addTrueBlurListener();
  },
  methods: {
    showSubInput(show) {
      if (show) {
        this.subTxtOrigin = this.txt;
        this.showSub = true;

        this.$emit('subFocus');
      } else {
        this.txt = this.subTxtOrigin;
        this.showSub = false;
        this.$emit('subBlur');
      }
    },

    startInput(e) {
      if (!this.disabled && !this.focus) {
        this.focus = true;

        this.$nextTick(() => {
          const txtarea = this.getInput();
          if (!txtarea) return;
          (txtarea !== e.target) && setTimeout(() => {
            txtarea.focus();
            txtarea.scrollTop = txtarea.scrollHeight;

            txtarea.setSelectionRange(
              txtarea.value.length,
              txtarea.value.length
            );
          });
          this.$emit('focus');
        });
      }
    },
    blur() {
      // this.txt = (this.txt && this.txt.trim()) || '';
      // const txtarea = this.getInput();
      // if (txtarea) {
      //   txtarea.scrollTop = 0;
      // }
      this.$nextTick(() => {
        this.focus = false;
        this.$emit('blur');
      });
    },
    getInput() {
      return this.$refs.inputRef;
    },
    setContent(val) {
      this.txt = val;

      this.startInput();
    },
    saveSub() {
      this.save();
      this.$refs.txtAsk.blur();
    },
    save() {
      if (this.disabled) {
        return;
      }
      this.subTxtOrigin = this.txt;
      this.$nextTick(() => {
        this.$emit('save', this.txt);
      });
      // this.blur();
    },
    trueBlurListenerStart(event) {
      this.trueBlurListener(event, true);
    },
    trueBlurListener(event, isStart) {
      if (!isStart && !this.blurStart) return;
      this.blurStart = false;
      if (!this.focus) return;

      const targetElement = event.target;
      const excludeElement = document.getElementById(this.id);

      if (
        excludeElement &&
        !excludeElement.contains(targetElement) &&
        // !excludeElement.parentElement.contains(targetElement) &&
        !document.body.classList.contains('yxt-popup-parent--hidden') &&
        this.canBlur
      ) {
        if (isStart) {
          this.blurStart = true;
        } else {
          this.blur();
        }
      }
    },
    addTrueBlurListener() {
      document.addEventListener('mousedown', this.trueBlurListenerStart);
      document.addEventListener('mouseup', this.trueBlurListener);
    },
    removeTrueBlurListener() {
      document.removeEventListener('mousedown', this.trueBlurListenerStart);
      document.removeEventListener('mouseup', this.trueBlurListener);
    }
  },
  beforeDestroy() {
    this.removeTrueBlurListener();
  }
};
</script>
